import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  newLabel: {
    color: denim,
    borderColor: denim,
    borderRadius: 11,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 2,
    fontWeight: '700',
    width: indent * 2 + 5,
    height: indent + 2,
  },
});
